import * as constants from "./constants";

function storeValue(obj) {
  try {
    let storingValue = JSON.stringify(obj);
    localStorage.setItem('userInfo', storingValue);
  } catch (err) {
    console.log(err);
  }
}

function removeValue() {
  try {
    localStorage.removeItem('userInfo');
  } catch (err) {
    console.log(err);
  }
}

export default function Global(state = {
  userId: null,
  token: null,
  formState: null,
  errors: [],
  successes: []
}, action) {
  let newErrors = [];
  let newSuccesses = [];
  switch (action.type) {
    case constants.LOGIN:
      if (state.impersonating) { action.data.impersonating = true; }
      storeValue(action.data);
      return Object.assign({}, state, action.data);
    case constants.LOGOUT:
      removeValue();
      return Object.assign({}, state, {
        userId: null,
        token: null,
        formState: null,
        impersonating: undefined,
        errors: []
      });
    case constants.PUSH_ERROR:
      newErrors = state.errors ? state.errors : [];
      newErrors = newErrors.concat(action.data);
      return Object.assign({}, state, {
        errors: newErrors.slice(0)
      });
    case constants.POP_ERROR:
      newErrors = state.errors ? state.errors : [];
      newErrors = newErrors.filter(v => v.errType !== action.data);
      return Object.assign({}, state, {
        errors: newErrors
      });
    case constants.PUSH_SUCCESS:
      newSuccesses = state.successes ? state.successes : [];
      newSuccesses = newSuccesses.concat(action.data);
      return Object.assign({}, state, {
        successes: newSuccesses.slice(0)
      });
    case constants.POP_SUCCESS:
      newSuccesses = state.successes ? state.successes : [];
      newSuccesses = newSuccesses.filter(v => v.errType !== action.data);
      return Object.assign({}, state, {
        successes: newSuccesses
      });
    default:
      return state;
  }
}
